import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Pagination from "../../Components/Pagination";
import Repo from "../../Utility/Repo";
import { Link } from "react-router-dom";
import ModalComponent from "../../Components/ModalComponent";
import { Input } from "design-react-kit";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import { useLocation, useHistory } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListUsers(props) {
  const apiToken = useContext(TokenContext);
  const [usersListAll, setUsersListAll] = useState([]); // lista completa
  const [usersListTemp, setUsersListTemp] = useState();
  const [usersList, setUsersList] = useState([]);
  const [isOpen, toggleModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [removableUser, setRemovableUser] = useState({});
  const [isModalBlock, setModalBlock] = useState(false);
  const [blockableUser, setBlockableUser] = useState({});
  const [allComuni, setAllComuni] = useState([]);
  const [hasUnspecifiedCity, setHasUnspecifiedCity] = useState(false);
  let query = useQuery();

  const EMPTY_CITY_FILTER_VALUE = "__EMPTY_CITY__";

  const isEmptyCity = (city) => city == null || String(city).trim() === "";

  const matchesCityFilter = (userCity, selectedCity) => {
    if (selectedCity === "") return true;
    if (selectedCity === EMPTY_CITY_FILTER_VALUE) return isEmptyCity(userCity);

    return userCity?.toLowerCase().includes(selectedCity.toLowerCase());
  };

  const [filter, setFilter] = useState({
    firstName: "",
    lastName: "",
    fiscalCode: "",
    email: "",
    phoneNumber: "",
    city: props?.comuneDelegate ? props?.comuneDelegate : "",
    loaded: false,
  });

  const sendFilter = () => {
    let filtered = usersListAll.filter((user) => {
      return (
        (filter.firstName === "" ||
          user.firstName
            ?.toLowerCase()
            .includes(filter.firstName.toLowerCase())) &&
        (filter.lastName === "" ||
          user.lastName
            ?.toLowerCase()
            .includes(filter.lastName.toLowerCase())) &&
        (filter.fiscalCode === "" ||
          user.fiscalCode
            ?.toLowerCase()
            .includes(filter.fiscalCode.toLowerCase())) &&
        (filter.email === "" ||
          user.email?.toLowerCase().includes(filter.email.toLowerCase())) &&
        (filter.phoneNumber === "" ||
          user.phoneNumber
            ?.toLowerCase()
            .includes(filter.phoneNumber.toLowerCase())) &&
        matchesCityFilter(user.city, filter.city)
      );
    });
    setUsersListTemp(filtered);
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    // Applica il filtro ogni volta che cambia un campo
    let filtered = usersListAll.filter((user) => {
      return (
        (newFilter.firstName === "" ||
          user.firstName
            ?.toLowerCase()
            .includes(newFilter.firstName.toLowerCase())) &&
        (newFilter.lastName === "" ||
          user.lastName
            ?.toLowerCase()
            .includes(newFilter.lastName.toLowerCase())) &&
        (newFilter.fiscalCode === "" ||
          user.fiscalCode
            ?.toLowerCase()
            .includes(newFilter.fiscalCode.toLowerCase())) &&
        (newFilter.email === "" ||
          user.email?.toLowerCase().includes(newFilter.email.toLowerCase())) &&
        (newFilter.phoneNumber === "" ||
          user.phoneNumber
            ?.toLowerCase()
            .includes(newFilter.phoneNumber.toLowerCase())) &&
        matchesCityFilter(user.city, newFilter.city)
      );
    });
    setUsersListTemp(filtered);
  };

  const handleReset = () => {
    const resetFilter = {
      firstName: "",
      lastName: "",
      fiscalCode: "",
      email: "",
      phoneNumber: "",
      city: props?.comuneDelegate ? props?.comuneDelegate : "",
      loaded: false,
    };
    setFilter(resetFilter);
    setUsersListTemp(usersListAll);
  };

  const removeUserAPI = () => {
    Repo.postDeleteUser(apiToken, removableUser.id)

      .then((response) => {
        if (response.status == 204) {
          window.location.href = props.subfolder + "/lista_utenti";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const userState = (userId) => {
    Repo.postUpdateUserStatus(apiToken, userId)
      .then((response) => {
        if (response.status == 204) {
          //window.location.reload();
          sendFilter();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    setLoading(true);
    Repo.getUsersList(apiToken, {})
      .then((response) => {
        setUsersListAll(response.data);
        setUsersListTemp(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
    Repo.getAllComuni(apiToken)
      .then((response) => {
        const comuniResponse = Array.isArray(response.data)
          ? response.data
          : [];
        const hasEmptyComune = comuniResponse.some((comune) =>
          isEmptyCity(comune),
        );

        let comuni = comuniResponse
          .filter((comune) => !isEmptyCity(comune))
          .map((comune) => String(comune).trim());

        if (props?.comuneDelegate && !comuni.includes(props.comuneDelegate)) {
          comuni = [...comuni, props.comuneDelegate];
        }

        setHasUnspecifiedCity(hasEmptyComune);
        setAllComuni(Array.from(new Set(comuni)));
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const parseItalianDate = (value) => {
    if (!value) return null;

    const parts = value.split("/");
    if (parts.length === 3) {
      const [day, month, year] = parts;
      return new Date(`${year}-${month}-${day}`);
    }

    const fallback = new Date(value);
    return Number.isNaN(fallback.getTime()) ? null : fallback;
  };

  const getAnprStatus = (dataAggAnpr, dataDecesso) => {
    if (dataDecesso && dataDecesso.trim().length > 0) {
      return "danger";
    }

    if (!dataAggAnpr) {
      return "danger";
    }

    const data = parseItalianDate(dataAggAnpr);
    if (!data) return "danger";

    const oggi = new Date();
    const diffMs = oggi - data;
    const diffGiorni = diffMs / (1000 * 60 * 60 * 24);

    if (diffGiorni <= 30) {
      return "success";
    }

    return "warning";
  };

  return (
    <>
      <div>
        <h1>Lista utenti</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>
            Tutti gli utenti caricati sul sistema. Da qui è possibile cercare un
            utente o aggiungere un nuovo utente.{" "}
          </p>
        </div>

        {/*Inizo cerca*/}

        <div className="row mt-2 text-right">
          <div className="col-lg-12 clearfix">
            <button
              type="button"
              className="btn btn-outline-primary float-right p-2"
              onClick={() =>
                (window.location.href =
                  window.location.pathname + "/nuovo_utente")
              }
            >
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-plus-circle`} />
              </svg>{" "}
              <span className="align-middle">Nuovo Utente</span>
            </button>
          </div>
        </div>

        <div className="mt-3 shadow-sm p-3 mb-5 bg-white rounded">
          <div className="row">
            <div className="form-group col-md-4">
              <Input
                id="first_name"
                required
                label="Nome"
                type="text"
                name="first_name"
                value={filter.firstName}
                onChange={(e) =>
                  handleFilterChange({ ...filter, firstName: e.target.value })
                }
              />
            </div>
            <div className="form-group col-md-4">
              <Input
                id="last_name"
                required
                label="Cognome"
                type="text"
                name="last_name"
                value={filter.lastName}
                onChange={(e) =>
                  handleFilterChange({ ...filter, lastName: e.target.value })
                }
              />
            </div>
            <div className="form-group col-md-4">
              <Input
                id="fiscal_code"
                required
                label="Codice Fiscale"
                type="text"
                name="fiscal_code"
                value={filter.fiscalCode}
                onChange={(e) =>
                  handleFilterChange({ ...filter, fiscalCode: e.target.value })
                }
              />
            </div>
            <div className="form-group col-md-3">
              <Input
                id="phone_number"
                required
                label="Telefono"
                type="text"
                name="phone_number"
                value={filter.phoneNumber}
                onChange={(e) =>
                  handleFilterChange({ ...filter, phoneNumber: e.target.value })
                }
              />
            </div>

            <div className="form-group col-md-3 ml-3">
              <label htmlFor="city" className="active">
                Seleziona comune*
              </label>
              <select
                id="city"
                name="city"
                className="form-control custom-textarea"
                value={filter.city}
                onChange={(e) =>
                  handleFilterChange({ ...filter, city: e.target.value })
                }
                disabled={props?.comuneDelegate ? true : false}
              >
                <option value="">Tutti</option>
                {hasUnspecifiedCity && (
                  <option value={EMPTY_CITY_FILTER_VALUE}>
                    Non specificato
                  </option>
                )}
                {allComuni?.length > 0 &&
                  allComuni?.map((comune) => (
                    <option key={comune} value={comune}>
                      {comune}
                    </option>
                  ))}
              </select>
            </div>

            <div className="form-group col-md-1 text-center">
              {/*<div className="form-check">
                <input
                  id="chkValidUserStatus"
                  type="checkbox"
                  checked={filter.loaded}
                  onChange={(e) =>
                    setFilter({ ...filter, loaded: e.target.checked })
                  }
                />
                <label htmlFor="chkValidUserStatus">Da validare</label>
              </div>*/}
            </div>

            <div className="form-group col-md-4 text-right">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={handleReset}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
        {/*Fine cerca*/}
        {usersListTemp && usersListTemp.length > 0 ? (
          <>
            <table className="table mt-3">
              <thead>
                <tr>
                  <th scope="col">Codice Fiscale</th>
                  <th scope="col">Nome</th>
                  <th scope="col">Cognome</th>

                  <th scope="col" className="text-center">
                    Ultimo ISEE
                  </th>
                  {props.isDelegate ? (
                    <th scope="col" alt="Data registrazione">
                      Data reg.
                    </th>
                  ) : (
                    <th scope="col" alt="Data registrazione">
                      Comune
                    </th>
                  )}
                  <th scope="col" className="text-center">
                    Agg ANPR
                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {usersList &&
                  usersList.length > 0 &&
                  usersList.map((x, index) => (
                    <React.Fragment key={index}>
                      <tr
                        className={`${
                          x.state === "LOADED"
                            ? "table-success"
                            : x.state === "SUSPEND"
                              ? "table-secondary"
                              : ""
                        }`}
                      >
                        <th scope="row">{x.fiscalCode}</th>
                        <td>{x.firstName}</td>
                        <td>{x.lastName}</td>
                        <td className="text-right">
                          {x.isees.length > 0 ? (
                            <>
                              {x.isees[x.isees.length - 1].value !== null && (
                                <>
                                  <span>
                                    {parseFloat(
                                      x.isees[x.isees.length - 1].value,
                                    ).toLocaleString("it-IT")}{" "}
                                    € (<b>{x.isees[x.isees.length - 1].year}</b>
                                    )
                                  </span>
                                  <br />

                                  {x.isees[x.isees.length - 1].state ===
                                  "VALIDATED" ? (
                                    <b className="text-success">
                                      <span
                                        className="icon-wrapper"
                                        title="Validato"
                                      >
                                        <svg className="icon icon-success">
                                          <use
                                            href={`${iconSprite}#it-check-circle`}
                                          ></use>
                                        </svg>
                                      </span>
                                    </b>
                                  ) : x.isees[x.isees.length - 1].state ===
                                    "LOADED" ? (
                                    <b className="text-success">
                                      <span
                                        className="icon-wrapper"
                                        title="Caricato"
                                      >
                                        <svg className="icon icon-warning">
                                          <use
                                            href={`${iconSprite}#it-warning`}
                                          ></use>
                                        </svg>
                                      </span>
                                    </b>
                                  ) : x.isees[x.isees.length - 1].state ===
                                    "REFUSED" ? (
                                    <b className="text-success">
                                      <span
                                        className="icon-wrapper"
                                        title="Rifiutato"
                                      >
                                        <svg className="icon icon-danger">
                                          <use
                                            href={`${iconSprite}#it-error`}
                                          ></use>
                                        </svg>
                                      </span>
                                    </b>
                                  ) : (
                                    x.isees[x.isees.length - 1].state
                                  )}
                                  {x.isees[x.isees.length - 1].hasFile ===
                                  true ? (
                                    <b className="text-success">
                                      <span title="Allegato caricato">
                                        <svg className="icon icon-secondary">
                                          <use
                                            href={`${iconSprite}#it-file`}
                                          ></use>
                                        </svg>
                                      </span>
                                    </b>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>N/A</>
                          )}
                        </td>

                        {props.isDelegate ? (
                          <td>{x.dataInsert}</td>
                        ) : (
                          <td>{x.city}</td>
                        )}

                        <td className="text-center">
                          <span
                            className="d-inline-flex align-middle"
                            title={
                              x.dataDecesso
                                ? `Deceduto il ${x.dataDecesso}`
                                : x.dataAggAnpr
                                  ? `Ultimo aggiornamento ANPR: ${x.dataAggAnpr}`
                                  : "Mai aggiornato ANPR"
                            }
                          >
                            <svg
                              className={`icon icon-${getAnprStatus(
                                x.dataAggAnpr,
                                x.dataDecesso,
                              )}`}
                            >
                              <use href={`${iconSprite}#it-user`} />
                            </svg>
                          </span>
                        </td>

                        <td className="text-right">
                          <button
                            className={`btn p-1 ${
                              x.state === "LOADED" ||
                              x.state === "REFUSED" ||
                              x.state === "SUSPEND"
                                ? "btn-outline-danger"
                                : "btn-outline-success"
                            }`}
                            data-toggle="tooltip"
                            data-placement="top"
                            title={
                              x &&
                              (x.state === "LOADED" ||
                                x.state === "REFUSED" ||
                                x.state === "SUSPEND")
                                ? "ABILITA"
                                : "SOSPENDI"
                            }
                            onClick={() => {
                              if (
                                x.state === "LOADED" ||
                                x.state === "REFUSED" ||
                                x.state === "SUSPEND"
                              ) {
                                userState(x.id);
                              } else {
                                setBlockableUser({
                                  firstName: x.firstName,
                                  lastName: x.lastName,
                                  id: x.id,
                                });
                                setModalBlock(true);
                              }
                            }}
                          >
                            <svg
                              className={`icon p-1 ${
                                x.state === "LOADED" ||
                                x.state === "REFUSED" ||
                                x.state === "SUSPEND"
                                  ? "icon-danger"
                                  : "icon-success"
                              }`}
                            >
                              <use
                                href={`${iconSprite}#${
                                  x.state === "LOADED" ||
                                  x.state === "REFUSED" ||
                                  x.state === "SUSPEND"
                                    ? "it-locked"
                                    : "it-unlocked"
                                }`}
                              />
                            </svg>
                          </button>
                          <Link
                            to={"/lista_utenti/cartella_sociale?id=" + x.id}
                          >
                            <button
                              className="btn btn-outline-primary p-1 ml-1"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Cartella sociale"
                            >
                              <svg className="icon icon-primary">
                                <use href={`${iconSprite}#it-folder`} />
                              </svg>
                            </button>
                          </Link>
                          {x.isees.length > 0 ? (
                            <button
                              className="btn btn-outline-secondary disabled p-1 ml-1"
                              type="button"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Non è possibile cancellare un utente se ha dati collegati!"
                            >
                              <svg className="icon icon-secondary">
                                <use href={`${iconSprite}#it-delete`} />
                              </svg>
                            </button>
                          ) : (
                            <button
                              className="btn btn-outline-danger p-1 ml-1"
                              type="button"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="È possibile eliminare l'utente solo se non ha caricato ISEE"
                              onClick={() => {
                                toggleModal(!isOpen);
                                setRemovableUser({
                                  firstName: x.firstName,
                                  lastName: x.lastName,
                                  id: x.id,
                                });
                              }}
                            >
                              <svg className="icon icon-danger">
                                <use href={`${iconSprite}#it-delete`} />
                              </svg>
                            </button>
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
            {usersListTemp && (
              <Pagination
                items={usersListTemp}
                setCurrentItems={setUsersList}
                itemsPerPage={15}
              ></Pagination>
            )}
          </>
        ) : (
          <div className="alert alert-warning" role="alert">
            Nessun utente trovato "<b>Attenzione!</b>".
          </div>
        )}
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header={
          "Rimozione utente: " +
          removableUser.firstName +
          " " +
          removableUser.lastName
        }
        body={
          "Confermi di voler rimuovere " +
          removableUser.firstName +
          " " +
          removableUser.lastName +
          "?"
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => removeUserAPI()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={setModalBlock}
        isOpen={isModalBlock}
        header={`Blocca: ${blockableUser.firstName} ${blockableUser.lastName}`}
        body={`Confermi di voler bloccare ${blockableUser.firstName} ${blockableUser.lastName}? Tutti i bandi collegati saranno bloccati di conseguenza.`}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => {
          userState(blockableUser.id);
          setModalBlock(false);
        }}
      />

      {loading && <Loader></Loader>}
    </>
  );
}

export default ListUsers;
